import { Card, Chip, styled } from "@mui/material";

import { Category } from "../types";

export const Container = styled("div")`
    padding: 30px;
`;

export const SessionContainer = styled(Card)`
    border: 2px solid ${({ theme }) => theme.palette.primary.main};
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 20px;
`;

export const SessionHeadline = styled("div")`
    display: flex;
    justify-content: space-between;
`;

export const ChipWrapper = styled("div")`
    margin-top: 10px;
`;

interface ChipProps {
    category: Category;
}

export const StyledChip = styled(Chip)<ChipProps>`
    color: white;
    margin-right: 8px;
    margin-bottom: 8px;
    background-color: ${({ theme, category }) => theme.colors[category]};
`;

export const ButtonContainer = styled("div")`
    width: 100%;
    display: flex;
    justify-content: center;
`;

export const ChartContainer = styled("div")`
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 20px 0;
    align-items: flex-end;
`;

export const StyledImage = styled("img")`
    display: flex;
    width: 80%;
`;

export const ImageContainer = styled("div")`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
